<div class="flex flex-column align-items-center text-center p-2">
    <!-- Icon Container -->
    <div class="flex align-items-center justify-content-center border-circle bg-red-50 text-red-500 mb-4" style="width: 5rem; height: 5rem;">
        <i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i>
    </div>
    
    <!-- Text Elements -->
    <h2 class="m-0 text-900 font-bold text-2xl mb-3">{{title}}</h2>
    <p class="m-0 text-600 line-height-3 mb-5 px-2" style="max-height: 15rem; overflow-y: auto;">
        {{message}}
    </p>

    <!-- Actions Footer -->
    <div class="flex justify-content-center gap-3 w-full border-top-1 surface-border pt-4">
        <p-button *ngIf="customError?.code == 'CE-1000'" label="Recargar" icon="pi pi-refresh" severity="secondary" [outlined]="true" [style]="{width: '100%'}" class="flex-1" (onClick)="reload()"></p-button>
        <p-button label="Entendido" icon="pi pi-check" severity="danger" [style]="{width: '100%'}" [class]="customError?.code == 'CE-1000' ? 'flex-1' : 'w-8'" (onClick)="closeDialog()"></p-button>
    </div>
</div>